import { Edge } from "reactflow";
import { useCallback } from "react";

import { useSetAtom } from "jotai";
import { edgesAtom, EdgeData } from "@zapier/canvas-state";

export const useUpdateEdge = () => {
  const setEdges = useSetAtom(edgesAtom);

  /**
   * Updates the properties of the current edge.
   *
   * This function accepts a partial edge object and merges it
   * with the current edge's properties, creating a new edge object.
   * This ensures React Flow is notified of the change.
   */
  return useCallback(
    (partialEdge: Partial<Edge<Partial<EdgeData>>>) => {
      setEdges((edges: Edge[]) => {
        return edges.map((edge) => {
          if (edge.id === partialEdge.id) {
            // it's important that we create a new object here
            // in order to notify react flow about the change
            return {
              ...edge,
              ...partialEdge,
            };
          }

          return edge;
        });
      });
    },
    [setEdges],
  );
};
